// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__13SaN","rootSmall":"AddTileButton_rootSmall__2oYc8"};